import type { OperationVariables } from '@apollo/client'
import type { ApolloUseQueryResult } from '@vivaldis/graphql'
import { useQuery as useQueryBase } from '@apollo/client/react'
import { createContext, useContext, PropsWithChildren, useMemo } from 'react'
import {
  SuEmployeesWithMissingSafetyAnswersSidebarQuery,
  SuEmployeesWithMissingSafetyAnswersSidebarQuery_suEmployeesWithMissingSafetyAnswers
} from '../graphql/__generated__/SuEmployeesWithMissingSafetyAnswersSidebarQuery'
import { suEmployeesWithMissingSafetyAnswersSidebarQuery } from '../graphql/suEmployeesWithMissingSafetyAnswersSidebarQuery'

export type SuEmployeesWithMissingSafetyAnswersQueryContextValue =
  ApolloUseQueryResult<
    SuEmployeesWithMissingSafetyAnswersSidebarQuery,
    OperationVariables,
    'empty' | 'complete' | 'streaming',
    OperationVariables
  >

export const QueryContext = createContext<
  SuEmployeesWithMissingSafetyAnswersQueryContextValue | undefined
>(undefined)

export function useSuEmployeesWithMissingSafetyAnswersQuery(): SuEmployeesWithMissingSafetyAnswersQueryContextValue {
  return useContext(QueryContext)!
}

export function useSuEmployeesWithMissingSafetyAnswers(): SuEmployeesWithMissingSafetyAnswersSidebarQuery_suEmployeesWithMissingSafetyAnswers[] {
  const { data } = useSuEmployeesWithMissingSafetyAnswersQuery()
  return useMemo(() => {
    return data?.suEmployeesWithMissingSafetyAnswers || []
  }, [data?.suEmployeesWithMissingSafetyAnswers])
}

export const SuEmployeesWithMissingSafetyAnswersQueryProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const queryResult = useQueryBase(
    suEmployeesWithMissingSafetyAnswersSidebarQuery
  )

  return (
    <QueryContext.Provider value={queryResult}>
      {children}
    </QueryContext.Provider>
  )
}
